module.exports = __webpack_public_path__ + "img/ic_more.6af3b71e.svg";